<app-schedule-filter *ngIf="showFilters" [filterItems]="filterItems" [disabled]="isLoading" [applyFilterBtnText]="data.mobileFilterApplyBtnText" (setValue)="filterPeriodChande($event)" />

<div class="schedule-box">
  <div class="time-col">
    <div *ngIf="showDaysName" class="cell"></div>
    <div *ngFor="let timeCell of timeRange" class="cell">
      {{ timeCell < 10 && '0' + timeCell || timeCell }}:00
    </div>
  </div>

  <div *ngIf="!isLoading" class="schedule-content">
    <div *ngIf="showDaysName" class="row header-days">
      <div *ngFor="let day of days; let i = index" class="col day-cell" [ngClass]="{ active: activeDay === i }">
        <div class="day-name">{{ day }}</div>
        <button class="no-style day-btn" [ngClass]="{ active: activeDay === i }" (click)="activeDay = i" [@openClose]="activeDay === i ? 'opened' : 'closed'">
          <span *ngIf="LocalizationService.showHebrewElements()">{{ activeDay === i ? day : i | hebrewDayName }}</span>
          <span *ngIf="!LocalizationService.showHebrewElements()">{{ activeDay === i ? day : i | shortDayOfWeek: true }}</span>
        </button>
      </div>
    </div>

    <div class="row schedule-days">
      <app-schedule-col
        *ngFor="let day of days; let i = index"
        [data]="schedule[i]"
        [timeRange]="timeRange"
        [active]="activeDay === i"
        [noResultsTitle]="data.mobileNoAnyLessonInCurrentDayText"
        [showFullNoResult]="false"
      />
    </div>
  </div>
  
  <div *ngIf="isLoading" class="schedule-content skeleton">
    <div *ngIf="showDaysName" class="row header-days">
      <div *ngFor="let day of days; let i = index" class="col day-cell" [ngClass]="{ active: activeDay === i }">
        <div class="day-name">{{ day }}</div>
        <button class="no-style day-btn" [ngClass]="{ active: activeDay === i }" (click)="activeDay = i" [@openClose]="activeDay === i ? 'opened' : 'closed'">
          <span *ngIf="LocalizationService.showHebrewElements()">{{ activeDay === i ? day : i | hebrewDayName }}</span>
          <span *ngIf="!LocalizationService.showHebrewElements()">{{ activeDay === i ? day : i | shortDayOfWeek: true }}</span>
        </button>
      </div>
    </div>

    <div class="row schedule-days" *ngIf="mobileMode">
      <app-skeleton *ngFor="let _ of [].constructor(3)" [height]="100"/>
    </div>
    
    <app-skeleton *ngIf="!mobileMode" [height]="812"/>
  </div>
</div>
